import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSkip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSkip"><Path d="M18.5 4.5V19.5M5.5 5L16.2143 12L5.5 19V5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSkip;
